import http from '@/http';

const autoPostService = {
  // Tạo job quét chạy nền, trả về jobId ngay (tránh bị nginx cắt kết nối)
  startCrawl(payload) {
    return http.post('/admin/auto-post/crawl/start', payload, { timeout: 60 * 1000 });
  },

  // Hỏi tiến độ + kéo các dòng log mới (since = seq dòng log cuối đã nhận)
  getCrawlStatus(jobId, since = 0) {
    return http.get(`/admin/auto-post/crawl/status/${jobId}`, {
      params: { since },
      timeout: 30 * 1000
    });
  },

  // Link tải toàn bộ log của job dạng file text
  crawlLogUrl(jobId) {
    return `${http.defaults.baseURL}/admin/auto-post/crawl/log/${jobId}`;
  },

  // Kiểm tra Chrome và quyền ghi thư mục ảnh trên server
  health() {
    return http.get('/admin/auto-post/health', { timeout: 90 * 1000 });
  },

  // Xoá 1 ảnh đã chụp
  deleteImage(image) {
    return http.delete('/admin/auto-post/image', { data: { image } });
  },

  // Tạo thumbnail 400px từ ảnh đã chọn
  makeThumbnail(image) {
    return http.post('/admin/auto-post/thumbnail', { image });
  },

  // Danh sách repo GitHub
  getRepos() {
    return http.get('/admin/auto-post/github/repos');
  },

  // Danh sách thư mục trong repo
  getFolders(repo, path = '') {
    return http.get('/admin/auto-post/github/folders', { params: { repo, path } });
  },

  // Đọc description.txt + email.txt của 1 thư mục
  getFolderContent(repo, folder) {
    return http.get('/admin/auto-post/github/content', { params: { repo, folder } });
  },

  // Đăng sản phẩm chính thức
  publish(payload) {
    return http.post('/admin/auto-post/publish', payload);
  },

  // Kiểm tra thư mục GitHub có file zip hay không
  getZipInfo(repo, folder) {
    return http.get('/admin/auto-post/github/zip', { params: { repo, folder } });
  },

  // Đẩy file zip của thư mục GitHub sang webhook product
  pushSource(payload) {
    // Tải zip từ GitHub rồi upload đi nên để timeout dài
    return http.post('/admin/auto-post/push-source', payload, { timeout: 10 * 60 * 1000 });
  }
};

export default autoPostService;
